<template>
  <invoice-mobile-success
    v-if="isMobileSuccessView"
    :id="mobileSuccessInvoiceId"
  />
  <v-app v-else style="width: 100%" class="pa-3 pt-0">
    <v-app-bar flat class="my-0 mb-2 py-1 px-4" dense height="30">
      <v-toolbar-title>
        {{ $t("print") }}
        {{ type !== "presale" ? $t("invoice") + " " + $t(type) : $t(type) }} : {{ id }}
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="$store.state.permissions && $store.state.permissions.includes(type)"
            v-shortkey="['f6']"
            v-bind="attrs"
            icon
            small
            class="float-left mt-1"
            @shortkey="goTo(type)"
            v-on="on"
            @click="goTo(type)"
          >
            <v-icon color="teal" style="font-size: 22px"> mdi-plus-box-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip v-if="entrepot" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f7']"
            v-bind="attrs"
            icon
            :disabled="entrepot ? false : true"
            small
            class="float-left mt-1"
            @shortkey="entrepotPrint()"
            v-on="on"
            @click="entrepotPrint()"
          >
            <v-icon color="orange" style="font-size: 22px"> mdi-warehouse </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(entrepot.type + "Print") }} (f7)</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="
              $store.state.permissions && $store.state.permissions.includes(type + 'Edit')
            "
            v-bind="attrs"
            icon
            small
            class="mt-1"
            v-on="on"
            @click="edit"
          >
            <v-icon color="primary" style="font-size: 22px"> mdi-clipboard-edit </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("edit") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            class="mt-1"
            small
            v-on="on"
            @click="goTo(type + 'List')"
          >
            <v-icon color="primary" style="font-size: 22px">
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("list") }} {{ $t(type) }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-row class="mx-0">
      <v-col cols="12">
        <v-btn
          v-shortkey="['f8']"
          color="primary"
          small
          class="me-2 mt-1 mb-1"
          outlined
          style="font-size: 12px"
          @shortkey="print"
          @click="print"
        >
          <v-icon color="pOrrange" style="font-size: 18px" class="me-2">
            mdi-printer-outline
          </v-icon>
          {{ $t("print") }} (f8)
        </v-btn>
        <v-btn
          color="primary"
          small
          class="me-2 mt-1 mb-1"
          outlined
          style="font-size: 12px"
          @click="captureAndSharePDF_2('pdf')"
          :loading="loading"
        >
          <v-icon color="pOrrange" style="font-size: 18px" class="me-2">
            mdi-file-pdf-box
          </v-icon>
          {{ $t("getFilepdf") }}
        </v-btn>
        <v-btn
          color="primary"
          small
          class="me-2 mt-1 mb-1"
          outlined
          style="font-size: 12px"
          @click="captureAndSharePDF_2('share')"
          :loading="loading"
        >
          <v-icon color="pOrrange" style="font-size: 18px" class="me-2">
            mdi-share-variant-outline
          </v-icon>
          {{ $t("shareInvoice") }}
        </v-btn>
        <v-btn
          color="primary"
          small
          class="me-2 mt-1 mb-1"
          outlined
          style="font-size: 12px"
          @click="invoiceSms"
        >
          <v-icon color="pOrrange" style="font-size: 18px" class="me-2">
            mdi-message-reply-text-outline
          </v-icon>
          {{ $t("sendInvoiceSMS") }}
        </v-btn>
        <v-btn
          v-clipboard:copy="
            'https://abr.abriron.com/print/invoice/' +
            $route.params.id +
            '?cuid=' +
            $store.state.cuid
          "
          class="mt-1 me-2 mb-1"
          small
          color="primary"
          outlined
          style="font-size: 12px"
          @click="copied"
        >
          <v-icon color="pOrrange" style="font-size: 18px" class="me-2">
            mdi-content-copy
          </v-icon>
          {{ $t("copyInvoiceLink") }}
        </v-btn>
        <telegram-button
          :url="
            'https://abr.abriron.com/print/invoice/' +
            $route.params.id +
            '?cuid=' +
            $store.state.cuid
          "
          btn-text=""
          class="mt-1 me-2"
          :has-icon="true"
          :description="$t('invoice') + ' - ' + $t(type)"
        />
        <whatsapp-button
          :url="
            'https://abr.abriron.com/print/invoice/' +
            $route.params.id +
            '?cuid=' +
            $store.state.cuid
          "
          btn-text=""
          class="mt-1 me-2"
          :has-icon="true"
        />
      </v-col>
    </v-row>
    <v-row class="mx-3 mb-4 mt-0">
      <v-expansion-panels v-model="panel" class="mt-2 px-0">
        <v-expansion-panel>
          <v-expansion-panel-header>
            {{ $t("printAndPageSetting") }}
            ✏️
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col>
                <v-chip-group
                  v-model="printType"
                  active-class="deep-purple--text text--accent-4"
                  mandatory
                >
                  <v-chip small value="unofficial">
                    {{ $t("unofficial") }}
                  </v-chip>
                  <v-chip small value="official">
                    {{ $t("official") }}
                  </v-chip>
                </v-chip-group>
              </v-col>
              <v-col>
                <v-checkbox
                  v-model="showProductCode"
                  class="mt-1 mx-4"
                  :label="$t('showProductCode')"
                />
              </v-col>
              <v-col>
                <v-checkbox
                  v-model="showEntrepotArticle"
                  class="mt-1 mx-4"
                  :label="$t('showEntrepotArticle')"
                />
              </v-col>
              <v-col>
                <v-checkbox
                  v-model="showRemain"
                  class="mt-1 mx-4"
                  :label="$t('showRemain')"
                />
              </v-col>
              <v-col>
                <v-checkbox
                  v-model="showArticleContent"
                  class="mt-1 mx-4"
                  :label="$t('showArticleContent')"
                />
              </v-col>
              <!-- add serial setting -->
              <v-col>
                <v-checkbox
                  v-model="showProductSerial"
                  class="mt-1 mx-4"
                  :label="$t('showProductSerial')"
                />
              </v-col>
              <v-col>
                <v-checkbox
                  v-model="showProductTaxCode"
                  class="mt-1 mx-4"
                  :label="$t('showProductTaxCode')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col md="3">
                <v-text-field
                  v-model="innerPageHeight"
                  height="20"
                  dense
                  outlined
                  class="mb-3 dense"
                  clearable
                  type="number"
                  :label="$t('innerPageHeight') + '(500~900)'"
                  @blur="renderPrinter"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col md="3">
                <p class="mb-0 mt-1">{{ $t("orientationPage&size") }} :</p>
              </v-col>
              <v-col md="3">
                <v-radio-group v-model="size" row hide-details class="me-9 mt-0">
                  <v-radio :label="$t('A5')" value="a5" />
                  <v-radio :label="$t('A4')" value="a4" />
                </v-radio-group>
              </v-col>
              <v-col md="3">
                <v-radio-group v-model="layout" row hide-details class="mt-0">
                  <v-radio :label="$t('portrait')" value="portrait" />
                  <v-radio :label="$t('landscape')" value="landscape" />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="layout === 'portrait'" class="setting-layout">
              <v-col cols="12" md="6">
                {{ $t("designing") }} : <templateSelector v-model="template" />
              </v-col>
              <v-col cols="12" md="6">
                {{ $t("coloring") }} : <colorSelector v-model="color" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <div
      id="print"
      style="direction: rtl; background-color: white; color: #000000"
      class="px-3 mx-auto main-layout"
      :style="{
        zoom: isMobile && !pdfGenerate ? (layout === 'portrait' ? '0.45' : '0.33') : null,
        'main-layout': isMobile && !pdfGenerate ? '0.45' : '1',
      }"
    >
      <div
        v-for="(page, i) in printPage"
        :key="i"
        :class="[layoutClass]"
        class="pagemargins"
        :style="{ 'page-break-before': i > 0 ? 'always' : null }"
      >
        <!--        header-->
        <div class="header-print" style="border: 0px !important">
          <div v-if="template && color" class="page-background-print">
            <printBackground
              :template="template + (layout === 'landscape' ? '-land' : '')"
              :color="color"
            />
          </div>
        </div>
        <!--        body-->
        <div
          class="body-print"
          style="z-index: 2; position: absolute; padding: 0cm 0.4cm"
          :style="{
            top: template && template !== 'undefined' && color ? '2.1cm' : '0.5cm',
          }"
        >
          <div
            v-show="!page.hideHeader"
            style="width: 100%; right: 0; margin-bottom: 0.4cm"
          >
            <div style="display: flex; width: 100%">
              <div style="width: 25%; padding-right: 1cm">
                <img
                  class="ms-2"
                  :src="base64Logo ? 'data:image/png;base64,' + base64Logo : ''"
                  width="65"
                />
              </div>
              <div style="width: 50%; text-align: center">
                <h3>
                  {{ type !== "presale" ? $t("invoice") + " " + $t(type) : $t(type) }}
                </h3>
                <h4>{{ self ? self.abrName : "" }}</h4>
                <h5 class="mt-1">{{ branch ? branch.name : "" }}</h5>
              </div>
              <div
                style="width: 25%; padding-right: 1cm; padding-top: 8px; font-size: 12px"
              >
                <div>{{ $t("date") }} : {{ date }}</div>
                <div>
                  {{ $t("number") }} : {{ officialNumber ? officialNumber : number }}
                </div>
              </div>
            </div>
            <div style="width: 100%; margin: 0.2cm 0cm">
              <div class="top-header-print">
                <div v-if="customer" style="width: 50%; padding: 10px 20px">
                  <div>
                    {{
                      $t(
                        type === "purchase" || type === "returnPurchase"
                          ? "seller"
                          : "buyer"
                      )
                    }}
                    :
                    {{
                      (customer && customer.gender && customer.gender !== "company"
                        ? $t(customer.gender)
                        : "") +
                      " " +
                      customer.name
                    }}
                  </div>
                  <div>
                    {{ $t("phone") }}:
                    {{
                      customer.phone && customer.phone !== "null" ? customer.phone : ""
                    }}
                  </div>
                  <div>
                    {{ $t("mobile") }}:
                    {{
                      customer.mobile && customer.mobile !== "null" ? customer.mobile : ""
                    }}
                  </div>
                  <div>
                    {{ $t("address") }}:
                    {{
                      customer.address && customer.address !== "null"
                        ? customer.address
                        : ""
                    }}
                  </div>
                  <div>
                    {{ $t("national-code") }}:
                    {{
                      customer.national_code && customer.national_code !== "null"
                        ? customer.national_code
                        : ""
                    }}
                  </div>
                  <div>
                    {{ $t("financial-code") }}:
                    {{
                      customer.financial_code && customer.financial_code !== "null"
                        ? customer.financial_code
                        : ""
                    }}
                  </div>
                </div>
                <div
                  v-if="printType === 'official'"
                  style="
                    width: 50%;
                    padding: 10px 20px;
                    border-right: 0.5px solid #000000;
                  "
                >
                  <div>
                    {{
                      type === "purchase" || type === "returnPurchase"
                        ? $t("buyer")
                        : $t("seller")
                    }}
                    : {{ self && self.abrName ? self.abrName : "" }}
                  </div>
                  <div>{{ $t("phone") }}: {{ self && self.phone ? self.phone : "" }}</div>
                  <div>
                    {{ $t("mobile") }}: {{ self && self.mobile ? self.mobile : "" }}
                  </div>
                  <div>
                    {{ $t("address") }}: {{ self && self.address ? self.address : "" }}
                  </div>
                  <div>
                    {{ $t("national-code") }}:
                    {{ self && self.nationalCode ? self.nationalCode : "" }}
                  </div>
                  <div>
                    {{ $t("financial-code") }}:
                    {{ self && self.financialCode ? self.financialCode : "" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--          table header-->
          <div v-show="!page.hideHeader" class="table-header-print">
            <div class="table-header-td-print" style="width: 3%">#</div>
            <div class="table-header-td-print" style="width: 30%">
              {{ $t("product") }} / {{ $t("service") }}
            </div>
            <div class="table-header-td-print" style="width: 8%">
              {{ $t("unit") }}
            </div>
            <div class="table-header-td-print" style="width: 8%">
              {{ $t("count") }}
            </div>
            <div class="table-header-td-print" style="width: 12%">
              {{ $t("fee") }} ({{ currency ? currency.symbol : "" }})
            </div>
            <div class="table-header-td-print" style="width: 12%">
              {{ $t("discount") }} ({{ currency ? currency.symbol : "" }})
            </div>
            <div class="table-header-td-print" style="width: 12%">
              {{ $t("tax") }} ({{ currency ? currency.symbol : "" }})
            </div>
            <div class="table-header-td-print" style="width: 15%">
              {{ $t("sum") }} ({{ currency ? currency.symbol : "" }})
            </div>
          </div>
          <!--          table body-->
          <div
            v-for="(item, m) in page.items"
            :key="m"
            style="display: flex"
            class="print-article show-header"
            v-html="item"
          />
        </div>
        <div
          class="footer-page-print"
          :style="{ bottom: template && color ? '25px' : '13px' }"
        >
          {{ $t("page") }} {{ page.page }} {{ $t("from") }} {{ printPage.length }}
        </div>
        <div
          class="footer-abriron-print"
          :style="{ bottom: template && color ? '25px' : '13px' }"
        >
          {{ $t("FinancialSolutionsAbriron") }}
        </div>
      </div>
    </div>
    <div ref="refItems" style="display: none; width: 21cm">
      <div
        v-for="(item, j) in items"
        :key="j"
        style="display: flex"
        class="print-row print-row-article"
      >
        <div class="table-body-td-print" style="width: 3%">
          {{ j + 1 }}
        </div>
        <div class="table-body-td-print" style="width: 30%">
          <div class="pt-1 pb-1">
            {{ item.product.name.replace(/\s{2,}/g, " ").trim() }}
          </div>
          <div class="pt-1" v-if="resolveProductCode(item)">
            {{ resolveProductCode(item) }}
          </div>
          <div class="pt-1" v-if="entrepotArticleName(item)">
            {{ entrepotArticleName(item) }}
          </div>
          <div class="pt-1" v-if="resolveProductTaxCode(item)">
            {{ resolveProductTaxCode(item) }}
          </div>
          <div class="pt-1" v-if="resolveProductSerials(item)">
            {{ resolveProductSerials(item) }}
          </div>
          <div
            v-if="item.content && showArticleContent"
            style="border-top: 0.5px solid #e3e3e3; font-size: 10px; padding-top: 4px"
          >
            {{ $t("articleContent") }} :
            {{ item.content && item.content !== "0" ? item.content : "" }}
          </div>
          <div
            v-if="item.product.kind_id === 112"
            style="border-top: 0.5px solid #e3e3e3; font-size: 10px; padding-top: 4px"
          >
            <div>
              {{ $t("construction_wages") }} :
              {{ $numberFormat(item.construction_wages) }}
            </div>
            <div>{{ $t("profit") }} : {{ $numberFormat(item.profit) }}</div>
            <div>{{ $t("goldCommission") }} : {{ $numberFormat(item.commission) }}</div>
          </div>
        </div>
        <div class="table-body-td-print" style="width: 8%">
          {{ item.unit ? item.unit.fame : "" }}
        </div>
        <div class="table-body-td-print" style="width: 8%">
          {{ $numberFormat(parseFloat(item.count), 3) }}
        </div>
        <div class="table-body-td-print" style="width: 12%">
          {{ $numberFormat(parseFloat(item.fee)) }}
        </div>
        <div class="table-body-td-print" style="width: 12%">
          {{ $numberFormat(parseFloat(item.discount)) }}
          {{
            item.discount && item.discount > 0
              ? parseFloat(
                  parseFloat(item.discountPercent || item.discount_percent || 0).toFixed(
                    2
                  )
                ) != 0
                ? "( " +
                  parseFloat(
                    parseFloat(item.discountPercent || item.discount_percent).toFixed(2)
                  ) +
                  " %)"
                : ""
              : ""
          }}
          <!-- {{
            item.discount && item.discount > 0
              ? (
                  (parseFloat(item.discount) / parseFloat(item.fee * item.count)) *
                  100
                ).toFixed(decimal) != 0
                ? "( " +
                  (
                    (parseFloat(item.discount) / parseFloat(item.fee * item.count)) *
                    100
                  ).toFixed(decimal) +
                  " %)"
                : ""
              : ""
          }} -->
        </div>
        <div class="table-body-td-print" style="width: 12%">
          {{ $numberFormat(parseFloat(item.tax)) }}
        </div>
        <div class="table-body-td-print" style="width: 15%">
          {{
            $numberFormat(
              (
                parseFloat(item.fee * item.count * item.cutieRate) +
                parseFloat(item.tax) -
                parseFloat(item.discount) +
                +item.construction_wages +
                +item.profit +
                +item.commission
              ).toFixed(decimal)
            )
          }}
        </div>
      </div>
      <!--      sum row-->
      <div class="print-row">
        <div class="table-body-td-print d-flex flex-column" style="width: 41%">
          <span>
            {{ $t("totalGrossAmount") }} :
            {{
              $numberFormat(
                items
                  .reduce(
                    (s, d) =>
                      s +
                      parseFloat(d.fee || 0) *
                        parseFloat(d.count || 0) *
                        parseFloat(d.cutieRate || 1),
                    0
                  )
                  .toFixed(decimal)
              )
            }}
            ({{ currency ? currency.symbol : "" }})
          </span>
          <span v-if="credit != 0">
            <div style="border-top: 1px solid silver"></div>
            {{ $t("club-credit") }}:{{ $numberFormat(credit) }}
          </span>
        </div>
        <div class="table-body-td-print" style="width: 8%">
          {{ $numberFormat(totals.count, 3) }}
        </div>
        <div class="table-body-td-print" style="width: 12%" />
        <div class="table-body-td-print" style="width: 12%">
          {{ $numberFormat(totalDiscount) }}
          {{
            ((totalDiscount / totals.fee) * 100).toFixed(decimal) != 0
              ? "( " + ((totalDiscount / totals.fee) * 100).toFixed(decimal) + " %)"
              : ""
          }}
        </div>
        <div class="table-body-td-print" style="width: 12%">
          {{ $numberFormat(totals.tax) }}
        </div>
        <div class="table-body-td-print" style="width: 15%">
          {{
            $numberFormat(
              parseFloat(totals.fee || 0) -
                parseFloat(totalDiscount || 0) -
                parseFloat(credit || 0) +
                parseFloat(totals.tax || 0) +
                parseFloat(totals.construction_wages || 0) +
                parseFloat(totals.profit || 0) +
                parseFloat(totals.commission || 0)
            )
          }}
        </div>
      </div>
      <!--      content row-->
      <div class="print-row">
        <div class="table-body-td-print" :style="{ width: showRemain ? '75%' : '100%' }">
          {{ $t("content") }} : {{ content }}
        </div>
        <div v-if="showRemain" class="table-body-td-print" style="width: 25%">
          {{ $t("remainAmountCustomer") }} :
          {{ $numberFormat(customer && customer.remain ? customer.remain.remain : 0) }}
          {{ $store.state.currency.name }}
        </div>
      </div>
      <!--      sign row-->
      <div class="print-row">
        <div class="table-body-td-print print-sign-box" style="width: 50%; height: 112px">
          <span class="print-sign-label">{{ $t("buyerSignature") }}</span>
          <div v-if="showCompanyAssetsInBuyerBox" class="print-sign-images">
            <img
              v-if="showCompanyStampInBuyerBox"
              :src="stampImageSrc"
              class="print-stamp-img"
              alt=""
            />
            <img
              v-if="showCompanySignatureInBuyerBox"
              :src="signatureImageSrc"
              class="print-signature-img"
              alt=""
            />
          </div>
        </div>
        <div class="table-body-td-print print-sign-box" style="width: 50%; height: 112px">
          <span class="print-sign-label">{{ $t("sellerSignature") }}</span>
          <div v-if="showCompanyAssetsInSellerBox" class="print-sign-images">
            <img
              v-if="showCompanyStampInSellerBox"
              :src="stampImageSrc"
              class="print-stamp-img"
              alt=""
            />
            <img
              v-if="showCompanySignatureInSellerBox"
              :src="signatureImageSrc"
              class="print-signature-img"
              alt=""
            />
          </div>
        </div>
      </div>
      <!--      invoice content row-->
      <div v-if="self && self.invoiceContent" class="print-row end-print">
        <div
          class="mt-2"
          style="font-size: 10px; text-align: justify; width: 100%"
          v-html="self.invoiceContent"
        />
      </div>
    </div>
    <v-dialog
      v-model="customSizeDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="60%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="customSizeDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print-size") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="width"
              outlined
              dense
              type="number"
              :label="$t('width') + '(cm)'"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="height"
              outlined
              dense
              type="number"
              :label="$t('height') + '(cm)'"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn color="primary" @click="setCustomeSize">
                {{ $t("submit") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="customSizeDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import store from "../../../../store";
import General from "../../../../Mixins/general";
import WhatsappButton from "vue-share-buttons/src/components/WhatsAppButton";
import TelegramButton from "vue-share-buttons/src/components/TelegramButton";
import templateSelector from "./partial/printTemplateSelector.vue";
import colorSelector from "./partial/printColorSelector.vue";
import printBackground from "./partial/printBackground.vue";
import InvoiceMobileSuccess from "./layouts/mobile/InvoiceMobileSuccess.vue";

const INVOICE_MOBILE_SUCCESS_MAX_WIDTH = 800;

export default {
  components: {
    templateSelector,
    colorSelector,
    TelegramButton,
    printBackground,
    WhatsappButton,
    InvoiceMobileSuccess,
  },
  mixins: [General],
  props: ["headerProp", "itemsProp", "title", "idProp"],
  data() {
    return {
      printPage: [],
      headerPrint: [],
      items: [],
      printType: "unofficial",
      timer: 0,
      innerPageHeight: null,
      loading: false,
      showRemain: false,
      size: "a4",
      layout: "portrait",
      base64Logo: null,
      base64Signature: null,
      base64Stamp: null,
      companySignatureEnabled: null,
      companyStampEnabled: null,
      signatureLink: null,
      stampLink: null,
      showArticleContent: null,
      template: null,
      showEntrepotArticle: null,
      showProductCode: null,
      color: null,
      type: null,
      snakbarColor: null,
      officialNumber: null,
      snakbarText: null,
      snakbar: null,
      content: null,
      id: null,
      date: null,
      account: null,
      number: null,
      currency_amount: null,
      dueDate: null,
      currency: null,
      tax: null,
      discount: null,
      entrepot: null,
      totalTax: null,
      totalDiscount: null,
      totalCount: null,
      totalFee: null,
      sum: null,
      uid: null,
      width: null,
      height: null,
      user: null,
      customer: null,
      currencyName: "",
      self: null,
      headers: null,
      pdfGenerate: false,
      decimal: 0,
      customSizeDialog: null,
      printSize: "29.7cm 21cm",
      branch: null,
      credit: null,
      showProductTaxCode: null,
      showProductSerial: null,
    };
  },
  computed: {
    // Only after mobile create redirect (?mobileSuccess=1) and narrow viewport.
    // Does not change normal invoicePrint / desktop print behavior.
    isMobileSuccessView() {
      const q = this.$route && this.$route.query ? this.$route.query : {};
      const flagged = String(q.mobileSuccess) === "1";
      const narrow =
        this.$vuetify &&
        this.$vuetify.breakpoint &&
        this.$vuetify.breakpoint.width < INVOICE_MOBILE_SUCCESS_MAX_WIDTH;
      return flagged && narrow;
    },
    mobileSuccessInvoiceId() {
      return (
        (this.$route && this.$route.params && this.$route.params.id) ||
        this.idProp ||
        this.id
      );
    },
    layoutClass() {
      var classObject = "";
      if (this.layout === "portrait") {
        classObject = {
          "main-page-print": true,
          "border-off": this.pdfGenerate,
        };
      } else {
        classObject = {
          "main-page-landscape-print": true,
          "border-off": this.pdfGenerate,
        };
      }
      return classObject;
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    totals: function () {
      const totals = this.items.reduce(
        (acc, d) => {
          acc.count += parseFloat(d.count);
          acc.fee += parseFloat(d.fee) * parseFloat(d.count) * parseFloat(d.cutieRate);
          acc.discount += parseFloat(d.discount);
          acc.tax += parseFloat(d.tax);
          acc.profit += parseFloat(d.profit ?? 0);
          acc.commission += parseFloat(d.commission ?? 0);
          acc.construction_wages += parseFloat(d.construction_wages ?? 0);
          return acc;
        },
        {
          count: 0,
          fee: 0,
          discount: 0,
          tax: 0,
          profit: 0,
          commission: 0,
          construction_wages: 0,
        }
      );
      totals.fee = totals.fee.toFixed(this.decimal);
      return totals;
    },
    signatureImageSrc() {
      if (this.base64Signature) {
        return "data:image/png;base64," + this.base64Signature;
      }
      return this.signatureLink || "";
    },
    stampImageSrc() {
      if (this.base64Stamp) {
        return "data:image/png;base64," + this.base64Stamp;
      }
      return this.stampLink || "";
    },
    showCompanyStampInSellerBox() {
      return (
        (this.type === "sell" || this.type === "presale" || this.type === "returnSell") &&
        this.companyStampEnabled !== "deactive" &&
        !!this.stampImageSrc
      );
    },
    showCompanySignatureInSellerBox() {
      return (
        (this.type === "sell" || this.type === "presale" || this.type === "returnSell") &&
        this.companySignatureEnabled !== "deactive" &&
        !!this.signatureImageSrc
      );
    },
    showCompanyStampInBuyerBox() {
      return (
        this.type === "purchase" &&
        this.companyStampEnabled !== "deactive" &&
        !!this.stampImageSrc
      );
    },
    showCompanySignatureInBuyerBox() {
      return (
        this.type === "purchase" &&
        this.companySignatureEnabled !== "deactive" &&
        !!this.signatureImageSrc
      );
    },
    showCompanyAssetsInSellerBox() {
      return this.showCompanyStampInSellerBox || this.showCompanySignatureInSellerBox;
    },
    showCompanyAssetsInBuyerBox() {
      return this.showCompanyStampInBuyerBox || this.showCompanySignatureInBuyerBox;
    },
  },
  watch: {
    // Leaving mobile success UI for PDF on the same invoicePrint component instance.
    "$route.query.autoPdf"(val) {
      if (String(val) !== "1" || this.isMobileSuccessView) return;
      this.$nextTick(() => {
        this.maybeRunAutoPdf(900);
      });
    },
    //add serial
    showProductSerial() {
      this.renderPrinter();
      this.setCookie("showProductSerial", this.showProductSerial);
    },
    //
    showProductCode() {
      this.renderPrinter();
      this.setCookie("showProductCode", this.showProductCode);
    },
    showEntrepotArticle() {
      this.renderPrinter();
      this.setCookie("showEntrepotArticle", this.showEntrepotArticle);
    },
    showRemain() {
      this.renderPrinter();
      this.setCookie("showRemain", this.showRemain);
    },
    showArticleContent() {
      this.renderPrinter();
      this.setCookie("showArticleContent", this.showArticleContent);
    },
    showProductTaxCode() {
      this.renderPrinter();
      this.setCookie("showProductTaxCode", this.showProductTaxCode);
    },
    printType() {
      this.setCookie("printType", this.printType);
    },
    template() {
      this.renderPrinter();
    },
    layout(val) {
      if (val === "landscape") {
        this.template = null;
      }
      this.renderPrinter();
      if (val) {
        localStorage.setItem("invoicePrintLayout", val);
      } else {
        localStorage.removeItem("invoicePrintLayout");
      }
    },
    size(val) {
      this.renderPrinter();
      if (val) {
        localStorage.setItem("invoicePrintSize", val);
      } else {
        localStorage.removeItem("invoicePrintSize");
      }
    },
    color(val) {
      // this.renderPrinter()
    },
    headerProp() {
      // this.head = this.itemsProp
    },
    itemsProp() {
      this.items = this.itemsProp;
    },
    items(val) {
      this.renderPrinter();
    },
  },
  beforeMount() {
    this.tableHeader();
    var storage = JSON.parse(localStorage.getItem("token"));
    if (storage != null) {
      store.commit("SET_START_DATE", storage.init.startDate);
      store.commit("SET_END_DATE", storage.init.endDate);
      store.commit("SET_DATE_LOCALE", storage.init.date_locale.value);
      if (storage.init.date_locale.value === "fa,en") {
        store.commit("SET_DATE_FORMAT", "jYYYY/jMM/jDD");
      } else {
        store.commit("SET_DATE_FORMAT", "YYYY/MM/DD");
        store.commit("SET_START_DATE", null);
        store.commit("SET_END_DATE", null);
      }
      store.commit("SET_RTL", storage.init.rtl.value);
      store.commit("SET_DARK", storage.init.dark.value);
      store.commit("SET_LANG", storage.init.lang.value);
      store.commit("SET_THEME_COLOR", storage.init.theme_color.value);
    }
    this.$vuetify.theme.dark = this.$store.state.dark;
    this.$root.$i18n.locale = this.$store.state.lang;
    this.$vuetify.theme.themes[
      this.$vuetify.theme.isDark ? "dark" : "light"
    ].primary = this.$store.state.theme_color;
    if (this.$store.state.rtl) {
      this.$vuetify.rtl = true;
      storage.init.rtl.value = true;
      localStorage.setItem("token", JSON.stringify(storage));
    } else {
      this.$vuetify.rtl = false;
    }
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.show();
    }
    if (this.idProp) {
      this.id = this.idProp;
      this.show();
    }
    var layout = localStorage.getItem("invoicePrintLayout");
    var size = localStorage.getItem("invoicePrintSize");
    if (layout !== undefined) {
      this.layout = layout;
    }
    if (size !== undefined) {
      this.size = size;
    }
    if (!this.size) {
      this.size = "a4";
    }
    if (!this.layout) {
      this.layout = "portrait";
    }
  },
  mounted() {
    this.setDefaultCooki();
  },
  methods: {
    //the best pdf performance
    waitForDomReady() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(resolve);
          });
        });
      });
    },
    waitForPrintImages(element) {
      if (!element) {
        return Promise.resolve();
      }
      const imgs = [...element.querySelectorAll("img")];
      return Promise.all(
        imgs.map((img) => {
          if (img.complete) {
            return Promise.resolve();
          }
          return new Promise((resolve) => {
            const done = () => resolve();
            img.addEventListener("load", done, { once: true });
            img.addEventListener("error", done, { once: true });
            setTimeout(done, 3000);
          });
        })
      );
    },
    getCaptureScale(element) {
      const maxSide = 12000;
      const rect = element.getBoundingClientRect();
      const longestSide = Math.max(rect.width, rect.height, 1);
      return Math.min(2, maxSide / longestSide);
    },
    buildPdfFileName() {
      return (
        this.$t(
          this.type !== "presale"
            ? this.$t("invoice") + " " + this.$t(this.type)
            : this.$t(this.type)
        ) +
        " " +
        this.customer.name +
        " " +
        this.$t("toNum") +
        " " +
        this.number +
        ".pdf"
      );
    },
    async buildPdfFromPageElements(pageElements, layout) {
      const imgWidth = layout === "p" ? 210 : 297;
      const pageHeightMm = layout === "p" ? 297 : 210;
      const pdf = window.jspdf.jsPDF(layout, "mm", "a4");

      for (let i = 0; i < pageElements.length; i++) {
        const pageEl = pageElements[i];
        const scale = this.getCaptureScale(pageEl);
        const canvas = await window.html2canvas(pageEl, {
          scale,
          useCORS: true,
          allowTaint: true,
          backgroundColor: "#ffffff",
          logging: false,
          scrollX: 0,
          scrollY: 0,
          windowWidth: pageEl.scrollWidth,
          windowHeight: pageEl.scrollHeight,
          onclone(clonedDoc) {
            const clonedPrint = clonedDoc.getElementById("print");
            if (clonedPrint) {
              clonedPrint.style.zoom = "1";
              clonedPrint.style.transform = "none";
            }
          },
        });

        const imgData = canvas.toDataURL("image/png");
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        const drawHeight = Math.min(imgHeight, pageHeightMm);

        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, drawHeight, null, "FAST");
      }

      return pdf;
    },
    async captureAndSharePDF_2(type) {
      this.pdfGenerate = true;
      this.loading = true;
      const app = this;

      try {
        if (!window.html2canvas || !window.jspdf) {
          throw new Error("PDF libraries not loaded");
        }

        if (!app.printPage || app.printPage.length === 0) {
          await new Promise((resolve) => setTimeout(resolve, 300));
        }

        await app.waitForDomReady();

        if (document.fonts && document.fonts.ready) {
          await document.fonts.ready;
        }

        const element = document.getElementById("print");
        if (!element) {
          throw new Error("Print element not found");
        }

        element.scrollIntoView({ block: "start" });
        await app.waitForPrintImages(element);

        const layout = app.layout === "portrait" ? "p" : "l";
        const pageSelector =
          app.layout === "portrait" ? ".main-page-print" : ".main-page-landscape-print";
        const pageElements = Array.from(element.querySelectorAll(pageSelector));

        if (!pageElements.length) {
          throw new Error("Print pages not found");
        }

        const pdf = await app.buildPdfFromPageElements(pageElements, layout);
        const nameFile = app.buildPdfFileName();

        if (type === "pdf") {
          pdf.save(nameFile);
          return;
        }

        const pdfBlob = pdf.output("blob");
        const file = new File([pdfBlob], nameFile, { type: "application/pdf" });

        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          try {
            await navigator.share({
              title: app.self.abrName + " - " + app.$t(app.type),
              text:
                app.self.abrName +
                "|" +
                app.$t(
                  app.type !== "presale"
                    ? app.$t("invoice") + " " + app.$t(app.type)
                    : app.$t(app.type)
                ) +
                " " +
                app.customer.name +
                " " +
                app.$t("toNum") +
                "   " +
                app.number,
              files: [file],
            });
          } catch (shareErr) {
            pdf.save(nameFile);
          }
        } else {
          pdf.save(nameFile);
        }
      } catch (err) {
        app.snakbarColor = "red";
        app.snakbarText = app.$t("error");
        app.snakbar = true;
      } finally {
        app.pdfGenerate = false;
        app.loading = false;
      }
    },
    // captureAndSharePDF(type) {
    //   this.pdfGenerate = true;
    //   var app = this;
    //   app.loading = true;
    //   setTimeout(function () {
    //     const element = document.getElementById("print");
    //     var layout = "l";
    //     var imgWidth = 297;
    //     var pageHeight = 210;
    //     if (app.layout === "portrait") {
    //       layout = "p";
    //       imgWidth = 210;
    //       pageHeight = 297;
    //     } else {
    //       layout = "l";
    //       imgWidth = 297;
    //       pageHeight = 210;
    //     }
    //     if (window.html2canvas) {
    //       window
    //         .html2canvas(element, {
    //           scale: 2,
    //           logging: true,
    //           letterRendering: 1,
    //         })
    //         .then((canvas) => {
    //           const imgData = canvas.toDataURL("image/png");
    //           const pdf = window.jspdf.jsPDF(layout, "mm", "a4");
    //           var imgHeight = (canvas.height * imgWidth) / canvas.width;
    //           var position = 0;
    //           var heightLeft = imgHeight;
    //           pdf.addImage(
    //             imgData,
    //             "PNG",
    //             0,
    //             position,
    //             imgWidth,
    //             imgHeight + 10,
    //             null,
    //             "FAST"
    //           );
    //           heightLeft -= pageHeight;
    //           while (heightLeft >= 0) {
    //             position = heightLeft - imgHeight;
    //             pdf.addPage();
    //             pdf.addImage(
    //               imgData,
    //               "PNG",
    //               0,
    //               position,
    //               imgWidth,
    //               imgHeight + 10,
    //               null,
    //               "FAST"
    //             );
    //             heightLeft -= pageHeight;
    //           }
    //           // pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight)
    //           var nameFile =
    //             app.$t(
    //               app.type !== "presale"
    //                 ? app.$t("invoice") + " " + app.$t(app.type)
    //                 : app.$t(app.type)
    //             ) +
    //             " " +
    //             app.customer.name +
    //             " " +
    //             app.$t("toNum") +
    //             " " +
    //             app.number +
    //             ".pdf";
    //           if (type === "pdf") {
    //             pdf.save(nameFile);
    //             app.pdfGenerate = false;
    //           } else {
    //             var pdfBlob = pdf.output("blob");
    //             if (
    //               navigator.canShare &&
    //               navigator.canShare({
    //                 files: [new File([pdfBlob], nameFile, { type: "application/pdf" })],
    //               })
    //             ) {
    //               var file = new File([pdfBlob], nameFile, { type: "application/pdf" });
    //               navigator
    //                 .share({
    //                   title: app.self.abrName + " - " + app.$t(app.type),
    //                   text:
    //                     app.self.abrName +
    //                     "|" +
    //                     app.$t(
    //                       app.type !== "presale"
    //                         ? app.$t("invoice") + " " + app.$t(app.type)
    //                         : app.$t(app.type)
    //                     ) +
    //                     " " +
    //                     app.customer.name +
    //                     " " +
    //                     app.$t("toNum") +
    //                     "   " +
    //                     app.number,
    //                   files: [file],
    //                 })
    //                 .then(() => {
    //                   app.pdfGenerate = false;
    //                 });
    //             } else {
    //             }
    //           }
    //         });
    //     } else {
    //     }
    //     app.loading = false;
    //   }, 200);
    // },
    //
    entrepotArticleName(item) {
      var content = "";
      if (this.entrepot && this.showEntrepotArticle) {
        content = this.$t("entrepot") + " : " + this.entrepot.entrepot.name;
      }
      if (item.article_entrepot && this.showEntrepotArticle) {
        content = this.$t("entrepot") + " : " + item.article_entrepot.name;
      }
      return content;
    },
    resolveProductCode(item) {
      if (this.showProductCode && item && item.product && item.product.code != null) {
        return this.$t("product-code") + " : " + item.product.code;
      } else {
        return "";
      }
    },
    resolveProductSerials(item) {
      if (!this.showProductSerial) return "";
      const serials = (item && item.product && item.product.serials) || [];
      const values = serials
        .map((s) => String((s && (s.serial || s.value)) || "").trim())
        .filter(Boolean);
      if (!values.length) return "";
      return this.$t("serial-numbers") + " : " + values.join(" ، ");
    },
    resolveProductTaxCode(item) {
      if (this.showProductTaxCode && item && item.product && item.product.taxid != null) {
        return this.$t("product-tax-code") + " : " + item.product.taxid;
      } else {
        return "";
      }
    },
    renderPrinter() {
      var app = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.printPage = [];
        app.$refs.refItems.style.display = "";
        setTimeout(function () {
          var minusHeight = 0;
          if (app.layout === "landscape") {
            minusHeight = 350;
          }
          var maxHeight = +800 - +minusHeight;
          if (app.template && app.color) {
            maxHeight = +650 - +minusHeight;
          }
          if (app.self && app.self.invoiceContent) {
            maxHeight = +700 - +minusHeight;
          }
          if (app.innerPageHeight > 500 && app.innerPageHeight < 900) {
            maxHeight = app.innerPageHeight;
          }
          var div = app.$refs.refItems;
          var divRow = div.getElementsByClassName("print-row");
          var startHeight = 0;
          var startHeightTemp = 0;
          var pageItems = [];
          var items = [];
          var tempitems = [];
          var pageHasArticle = false;
          var tempHasArticle = false;
          for (let j = 0; j < divRow.length; j++) {
            var rowHtml = divRow[j].innerHTML;
            var isArticle = divRow[j].classList.contains("print-row-article");
            startHeight = startHeight + divRow[j].getBoundingClientRect().height;
            if (startHeight <= maxHeight) {
              items.push(rowHtml);
              if (isArticle) {
                pageHasArticle = true;
              }
            } else {
              tempitems.push(rowHtml);
              if (isArticle) {
                tempHasArticle = true;
              }
              startHeightTemp = divRow[j].offsetHeight;
            }
            if (startHeight > maxHeight) {
              pageItems.push({ items: items, hasArticle: pageHasArticle });
              items = JSON.parse(JSON.stringify(tempitems));
              pageHasArticle = tempHasArticle;
              tempitems = [];
              tempHasArticle = false;
              startHeight = startHeightTemp;
            }
          }
          pageItems.push({ items: items, hasArticle: pageHasArticle });
          for (let i = 0; i < pageItems.length; i++) {
            if (!pageItems[i].items || !pageItems[i].items.length) {
              continue;
            }
            app.printPage.push({
              page: i + 1,
              itemStart: 0,
              itemEnd: 1,
              hideHeader: !pageItems[i].hasArticle,
              items: pageItems[i].items,
            });
          }
          app.printPage.forEach(function (page, index) {
            page.page = index + 1;
          });
        }, 100);
        setTimeout(function () {
          app.$refs.refItems.style.display = "none";
        }, 1000);
      }, 100);
    },
    setDefaultCooki() {
      var showRemain =
        this.getCookie("showRemain") !== null ? this.getCookie("showRemain") : null;
      if (showRemain) {
        if (showRemain === "true") {
          this.showRemain = true;
        } else {
          this.showRemain = false;
        }
      }
      var showProductCode =
        this.getCookie("showProductCode") !== null
          ? this.getCookie("showProductCode")
          : null;
      if (showProductCode) {
        if (showProductCode === "true") {
          this.showProductCode = true;
        } else {
          this.showProductCode = false;
        }
      }
      var showEntrepotArticle =
        this.getCookie("showEntrepotArticle") !== null
          ? this.getCookie("showEntrepotArticle")
          : null;
      if (showEntrepotArticle) {
        if (showEntrepotArticle === "true") {
          this.showEntrepotArticle = true;
        } else {
          this.showEntrepotArticle = false;
        }
      }
      var showArticleContent =
        this.getCookie("showArticleContent") !== null
          ? this.getCookie("showArticleContent")
          : null;
      if (showArticleContent) {
        if (showArticleContent === "true") {
          this.showArticleContent = true;
        } else {
          this.showArticleContent = false;
        }
      }
      var showProductTaxCode =
        this.getCookie("showProductTaxCode") !== null
          ? this.getCookie("showProductTaxCode")
          : null;
      if (showProductTaxCode) {
        if (showProductTaxCode === "true") {
          this.showProductTaxCode = true;
        } else {
          this.showProductTaxCode = false;
        }
      }
      var showProductSerial =
        this.getCookie("showProductSerial") !== null
          ? this.getCookie("showProductSerial")
          : null;
      if (showProductSerial) {
        if (showProductSerial === "true") {
          this.showProductSerial = true;
        } else {
          this.showProductSerial = false;
        }
      }
      var printType =
        this.getCookie("printType") !== null ? this.getCookie("printType") : null;
      if (printType) {
        this.printType = printType;
      }
    },
    edit() {
      this.$router.push({ name: this.type + "Edit", params: { id: this.uid } });
    },
    entrepotPrint() {
      this.$router.push({
        name: this.entrepot.type + "Print",
        params: { id: this.entrepot.id },
      });
    },
    tableHeader() {
      if (this.printType === "official") {
        this.headers = [
          {
            text: this.$t("row"),
            align: "center",
            sortable: false,
            value: "row",
            width: 20,
          },
          {
            text: this.$t("product") + "/" + this.$t("service"),
            sortable: false,
            value: "product",
            align: "center",
          },
          {
            text: this.$t("unit"),
            sortable: false,
            value: "unit",
            align: "center",
          },
          {
            text: this.$t("count"),
            sortable: false,
            value: "count",
            align: "center",
          },
          {
            text: this.$t("fee") + "(" + this.currencyName + ")",
            sortable: false,
            value: "fee",
            align: "center",
          },
          {
            text: this.$t("discount") + "(" + this.currencyName + ")",
            sortable: false,
            value: "discount",
            align: "center",
          },
          {
            text: this.$t("tax") + "(" + this.currencyName + ")",
            sortable: false,
            value: "tax",
            align: "center",
          },
          {
            text: this.$t("sum") + "(" + this.currencyName + ")",
            sortable: false,
            value: "sum",
            align: "center",
          },
          {
            text: this.$t("finalAmount") + "(" + this.currencyName + ")",
            sortable: false,
            value: "finalAmount",
            align: "center",
          },
        ];
      } else {
        this.headers = [
          {
            text: this.$t("row"),
            align: "center",
            sortable: false,
            value: "row",
            width: 20,
          },
          {
            text: this.$t("product") + "/" + this.$t("service"),
            sortable: false,
            value: "product",
            align: "center",
          },
          {
            text: this.$t("unit"),
            sortable: false,
            value: "unit",
            align: "center",
          },
          {
            text: this.$t("count"),
            sortable: false,
            value: "count",
            align: "center",
          },
          {
            text: this.$t("fee") + "(" + this.currencyName + ")",
            sortable: false,
            value: "fee",
            align: "center",
          },
          {
            text: this.$t("discount") + "(" + this.currencyName + ")",
            sortable: false,
            value: "discount",
            align: "center",
          },
          {
            text: this.$t("tax") + "(" + this.currencyName + ")",
            sortable: false,
            value: "tax",
            align: "center",
          },
          {
            text: this.$t("sum") + "(" + this.currencyName + ")",
            sortable: false,
            value: "sum",
            align: "center",
          },
          {
            text: this.$t("finalAmount") + "(" + this.currencyName + ")",
            sortable: false,
            value: "finalAmount",
            align: "center",
          },
          {
            text: this.$t("rowContent"),
            sortable: false,
            value: "content",
            align: "center",
          },
        ];
      }
    },
    show() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "invoice/" + this.id + "/edit", {
          params: {
            id: this.idProp,
            print: "active",
          },
        })
        .then((res) => {
          app.$nextTick(() => {
            res = res.data;
            app.id = res.id;
            app.currency = res.currency;
            app.currency_amount = res.currency_amount;
            app.currencyName = res.currency.name;
            app.decimal = res.currency ? res.currency.decimal : 0;
            app.tableHeader();
            app.number = res.number;
            app.officialNumber = res.official_number;
            app.content = res.content;
            app.date = res.date;
            app.type = res.type;
            app.uid = res.uid;
            app.items = res.article;
            app.account = res.customer;
            app.entrepot = res.entrepot;
            app.branch = res.branch;
            app.dueDate = res.due_date;
            app.payments = res.payments;
            app.checks = res.checks;
            app.status = res.last_status ? res.last_status.status : null;
            app.discount = res.discount;
            app.totalDiscount = res.discount;
            app.totaltax = res.tax;
            app.user = res.user;
            app.customer = res.customer;
            app.self = res.self;
            app.credit = res.credit;
            app.loadCompanyPrintAssets().finally(() => {
              if (app.self && app.self.logo) {
                app.getBase64Logo();
              }
              setTimeout(function () {
                app.render = true;
                app.maybeRunAutoPdf(600);
              }, 1000);
            });
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    maybeRunAutoPdf(delayMs) {
      if (
        !this.$route ||
        !this.$route.query ||
        String(this.$route.query.autoPdf) !== "1"
      ) {
        return;
      }
      if (this.isMobileSuccessView) return;
      const wait = typeof delayMs === "number" ? delayMs : 600;
      this.$nextTick(() => {
        setTimeout(() => {
          if (typeof this.captureAndSharePDF_2 === "function") {
            this.captureAndSharePDF_2("pdf");
          }
        }, wait);
      });
    },
    clearCustom() {
      this.height = null;
      this.width = null;
    },
    setCustomeSize() {
      this.printSize = this.width + "cm " + this.height + "cm";
      this.customSizeDialog = false;
    },
    print() {
      var style =
        "<style>" +
        "@page {size: " +
        this.size +
        " " +
        this.layout +
        ";margin: 5px}" +
        "html {font-size: inherit !important; line-height:1.5},body { width: 190mm; height: 290mm} .pagemargins { padding: 5.08mm 10mm 5.08mm 10mm; border:0;direction: rtl; }" +
        "" +
        (this.$store.state.lang !== "fa" ? "body {font-family: arial !important;}" : "") +
        "</style>";
      setTimeout(function () {
        // Get HTML to print from element
        const prtHtml = document.getElementById("print").innerHTML;

        var stylesHtml = "";
        var node = null;
        for (node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
          stylesHtml += node.outerHTML;
        }

        const WinPrint = window.open(
          "",
          "",
          "left=0,top=0,width=1100,height=900,toolbar=0,scrollbars=0,status=0"
        );
        WinPrint.document.write(
          "<!DOCTYPE html> <html> <head> " +
            stylesHtml +
            " " +
            style +
            " </head> <body>" +
            prtHtml +
            " </body> </html>"
        );
        WinPrint.document.close();
        WinPrint.focus();
        setTimeout(function () {
          WinPrint.print();
          WinPrint.close();
        }, 2000);
      }, 50);
    },
    copied() {
      this.snakbarText = this.$t("copied");
      this.snakbarColor = "blue";
      this.snakbar = true;
    },
    getBase64Logo() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "getdetail?select=urlToBase64&url=" + app.self.logo.link)
        .then((res) => {
          res = res.data;
          app.base64Logo = res;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    parseActiveDeactive(value) {
      if (value === "active" || value === true || value === 1 || value === "1") {
        return "active";
      }
      return "deactive";
    },
    resolvePrintAssetLink(file) {
      if (!file) return null;
      if (typeof file === "string") return file;
      return file.link || file.url || null;
    },
    readPrintAssetEnabled(data, kind) {
      if (!data) return null;
      if (kind === "signature") {
        const value =
          data.companySignatureEnabled != null
            ? data.companySignatureEnabled
            : data.company_signature_enabled != null
            ? data.company_signature_enabled
            : data.signature_enabled;
        return value != null ? this.parseActiveDeactive(value) : null;
      }
      const value =
        data.companyStampEnabled != null
          ? data.companyStampEnabled
          : data.company_stamp_enabled != null
          ? data.company_stamp_enabled
          : data.stamp_enabled;
      return value != null ? this.parseActiveDeactive(value) : null;
    },
    readPrintAssetFile(data, kind) {
      if (!data) return null;
      if (kind === "signature") {
        return (
          data.signature ||
          data.companySignature ||
          data.company_signature ||
          data.signature_file ||
          data.signatureFile ||
          null
        );
      }
      return (
        data.stamp ||
        data.companyStamp ||
        data.company_stamp ||
        data.stamp_file ||
        data.stampFile ||
        null
      );
    },
    hasExplicitPrintAssetEnabled(data, kind) {
      if (!data) return false;
      if (kind === "signature") {
        return (
          data.companySignatureEnabled != null ||
          data.company_signature_enabled != null ||
          data.signature_enabled != null
        );
      }
      return (
        data.companyStampEnabled != null ||
        data.company_stamp_enabled != null ||
        data.stamp_enabled != null
      );
    },
    applyCompanyPrintAssetSettings(data) {
      if (!data) return;
      const signatureEnabled = this.readPrintAssetEnabled(data, "signature");
      const stampEnabled = this.readPrintAssetEnabled(data, "stamp");
      const signatureLink = this.resolvePrintAssetLink(
        this.readPrintAssetFile(data, "signature")
      );
      const stampLink = this.resolvePrintAssetLink(
        this.readPrintAssetFile(data, "stamp")
      );

      if (signatureLink) {
        this.signatureLink = signatureLink;
        if (!this.hasExplicitPrintAssetEnabled(data, "signature")) {
          this.companySignatureEnabled = "active";
        }
      }
      if (stampLink) {
        this.stampLink = stampLink;
        if (!this.hasExplicitPrintAssetEnabled(data, "stamp")) {
          this.companyStampEnabled = "active";
        }
      }

      if (
        this.hasExplicitPrintAssetEnabled(data, "signature") &&
        signatureEnabled != null
      ) {
        this.companySignatureEnabled = signatureEnabled;
      }
      if (this.hasExplicitPrintAssetEnabled(data, "stamp") && stampEnabled != null) {
        this.companyStampEnabled = stampEnabled;
      }

      if (Array.isArray(data.files)) {
        data.files.forEach((file) => {
          const type = (file.type || file.file_type || "").toLowerCase();
          if (type === "signature" && !this.signatureLink) {
            this.signatureLink = this.resolvePrintAssetLink(file);
            if (!this.hasExplicitPrintAssetEnabled(data, "signature")) {
              this.companySignatureEnabled = "active";
            }
          }
          if (type === "stamp" && !this.stampLink) {
            this.stampLink = this.resolvePrintAssetLink(file);
            if (!this.hasExplicitPrintAssetEnabled(data, "stamp")) {
              this.companyStampEnabled = "active";
            }
          }
        });
      }
    },
    fetchBase64Image(url, targetKey) {
      if (!url) return Promise.resolve();
      return this.$axios
        .get(
          this.$endpoint + "getdetail?select=urlToBase64&url=" + encodeURIComponent(url)
        )
        .then((res) => {
          this[targetKey] = res.data;
        })
        .catch(() => {});
    },
    normalizePrintSettingData(res) {
      if (!res) return null;
      if (
        res.data != null &&
        typeof res.data === "object" &&
        res.subtitle == null &&
        res.content == null
      ) {
        return res.data;
      }
      return res;
    },
    loadCompanyPrintAssets() {
      const app = this;
      app.base64Signature = null;
      app.base64Stamp = null;

      return app.$axios
        .get(app.$endpoint + "setting/1/edit", { params: { select: "invoicePrint" } })
        .then((res) => app.normalizePrintSettingData(res.data))
        .catch(() => null)
        .then((settingsData) => {
          app.applyCompanyPrintAssetSettings(app.self || {});
          app.applyCompanyPrintAssetSettings(settingsData || {});

          const loads = [];
          if (app.stampLink && app.companyStampEnabled !== "deactive") {
            loads.push(app.fetchBase64Image(app.stampLink, "base64Stamp"));
          }
          if (app.signatureLink && app.companySignatureEnabled !== "deactive") {
            loads.push(app.fetchBase64Image(app.signatureLink, "base64Signature"));
          }
          return Promise.all(loads).then(() => {
            app.renderPrinter();
          });
        });
    },
    invoiceSms(item) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            invoiceSMS: "active",
            id: app.id,
          },
        })
        .then((res) => {
          res = res.data;
          app.snakbarColor = "green";
          app.snakbarText = this.$t("sent");
          app.snakbar = true;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
  },
};
</script>

<style scoped>
.top-header-print {
  font-size: 11.5px;
  border-radius: 10px;
  border: 1px solid #292929;
  display: flex;
}
@page {
  /*size: A4 landscape;*/
}
@media print {
  @page {
    /*size: A4;*/
    margin: 0px;
    padding: 0;
  }
  .main-page-print {
    width: 21cm;
    height: 29.68cm;
    position: relative;
    border: 0px !important;
    padding: 10px;
    white-space: normal;
  }
  .main-page-landscape-print {
    border: 0px solid !important;
    padding: 10px;
    white-space: normal;
  }
  .table-header-td-print {
    -webkit-print-color-adjust: exact !important;
  }
  .body-print > .print-article:nth-child(even) > .table-body-td-print {
    -webkit-print-color-adjust: exact !important;
  }
}
.pagemargins {
  padding: 5.08mm 10mm 5.08mm 10mm;
  border: 0;
  direction: rtl;
}
.footer-page-print {
  position: absolute;
  bottom: 28px;
  border-radius: 10px;
  padding: 3px 7px;
  right: 0.5cm;
  background-color: #ffffff;
  font-size: 11px;
}
.footer-abriron-print {
  position: absolute;
  bottom: 28px;
  border-radius: 10px;
  padding: 3px 7px;
  left: 0.7cm;
  font-size: 9px;
  background-color: #ffffff;
  color: #1c1c1c;
}
.table-header-td-print {
  display: inline-block;
  width: 1cm;
  border: 0.5px solid #262626;
  height: 30px;
  font-size: 11px;
  border-left: none !important;
  padding: 5px;
  background-color: #e7e7e7;
}

.table-header-print {
  display: flex;
  width: 100%;
  /*margin: 0cm 0.2cm;*/
}
.border-off {
  border: 0px !important;
}
.main-page-landscape-print {
  width: 29.68cm;
  height: 20.8cm;
  position: relative;
  border: 0.5px solid;
  padding: 10px;
  white-space: normal;
}
.main-page-print {
  width: 21cm;
  height: 29.68cm;
  position: relative;
  border: 0.5px solid;
  padding: 10px;
  white-space: normal;
}
.body-print {
  direction: rtl;
  width: 100%;
  right: 0;
}
.body-print > .print-article:last-child > div:first-child {
  border-bottom-right-radius: 10px;
}
.body-print > .print-article:last-child > div:last-child {
  border-bottom-left-radius: 10px;
}
.share-button {
  width: 28px;
  height: 28px;
  min-width: 0px !important;
  min-height: 0px !important;
  padding: 0px 0px !important;
}
.page-background-print {
  position: absolute;
  width: 100%;
  top: 0;
  right: 0;
  padding: 10px;
}
.table-header-td-print:first-child {
  border-top-right-radius: 10px;
}
.table-header-td-print:last-child {
  border-top-left-radius: 10px;
  border-left: 0.5px solid #262626 !important;
}
.print-row > .table-body-td-print {
  /*border: 0.5px solid #ffffff;*/
  /*color: #ffffff*/
}
.table-body-td-print {
  display: inline-block;
  font-size: 11.5px;
  padding: 3pt;
  word-wrap: break-word;
  word-break: break-word;
  /*min-height: 25px;*/
  border-left: none !important;
  border-top: none !important;
  border: 0.5px solid #000000;
}
.table-body-td-print:last-child {
  border-left: 0.5px solid #000000 !important;
}
.print-article {
  display: flex;
  width: 100%;
  margin: 0cm 0cm;
}
.body-print > .print-article:nth-child(even) > .table-body-td-print {
  background-color: #e7e7e7;
}
.print-sign-box {
  position: relative;
  vertical-align: top;
}
.print-sign-label {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 11.5px;
  z-index: 1;
}
.print-sign-images {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  direction: ltr;
  height: 96px;
  max-width: calc(100% - 140px);
  overflow: visible;
}
.print-stamp-img {
  height: 96px;
  max-width: 130px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
}
.print-signature-img {
  height: 96px;
  max-width: 80px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
  margin-left: -47px;
  position: relative;
  z-index: 1;
}
@media only screen and (max-width: 870px) {
  /*.main-layout {*/
  /*  zoom: 0.45;*/
  /*}*/
}
</style>
